'use client';

import React, { useState, useEffect, useRef } from 'react';
import clsx from 'clsx';
import styles from './newsletter.module.scss';

// Add onSubmissionComplete prop
export function NewsletterSignup({ position = 'footer', onSubmissionComplete }) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [submitState, setSubmitState] = useState('initial');
  const timeoutRef = useRef(null);

  // Reset form after n seconds of success state
  useEffect(() => {
    const timeoutInMs = 4000

    if (submitState === 'success') {
      // Rest
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      
      // Set timeout
      timeoutRef.current = setTimeout(() => {
        setSubmitState('initial');
        setEmail('');
        setError('');
        timeoutRef.current = null;
      }, timeoutInMs);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, [submitState]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitState('loading');

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setSubmitState('initial');
      setError("Invalid email address");
      return;
    }

    // Get the current URL
    const currentUrl = window.location.href;

    try {
      const response = await fetch('/api/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, url: currentUrl, position: position }),
      });

      if (response.ok) {
        // Notify parent component of success
        onSubmissionComplete && onSubmissionComplete('success');
        setSubmitState('success');
      } else {
        // Notify parent component of error
        onSubmissionComplete && onSubmissionComplete('error');
        setSubmitState('initial');
        setError('Error');
      }
    } catch (error) {
      // Notify parent component of error
      onSubmissionComplete && onSubmissionComplete('error');
      setSubmitState('initial');
      setError('Error');
    }
  };

  return (
    <div className={clsx(styles.wrapper, styles[position])}>
      <div className={clsx(styles.box)}>
        { submitState !== 'success' && (
          <form onSubmit={handleSubmit} className={clsx(styles.form)}>
            
            <input
              name="email"
              type="email"
              placeholder={"Sign up to our newsletter"}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className={clsx(styles.input)}
            />

            {/* submit */}
            <button type="submit" className={clsx(styles.button)} tabIndex={20} disabled={submitState === 'loading'}>
              →
            </button>
          </form>
        )}

        { submitState == 'success' && (
          <div className={clsx(styles.success)}>You’re On Air. Speak soon!</div>
        )}
      </div>

      {error && (
        <div className={clsx(styles.error)}>{error}</div>
      )}
    </div>
  );
}